import * as React from 'react';

import {colors} from 'shells/colors/colors';
import type {CueCardCtaAction} from 'shells/cue-card/cue-card';
// @ts-expect-error
import {NutshellLogoMarkIcon} from 'shells/icon/svg/nutshell-logo-mark-icon';
import {VideoCameraRegularIcon} from 'shells/icon/svg/video-camera-regular-icon';

export type Offer = {
    id: string;
    title: string;
    description: string;
    icon: React.ComponentType<any>;
    exploreLink: string;
    illustration?: string | React.ReactNode;
    linkCTA?: string;
    expiresAt?: Date;
    actionType?: CueCardCtaAction;
};

export const ROADMAP_OFFER_ID = 'nutshell-2026-roadmap';

export const UPCOMING_OFFERS: Offer[] = [
    {
        id: ROADMAP_OFFER_ID,
        title: 'Nutshell‘s 2026 Roadmap',
        description: 'See what‘s coming next for Nutshell in 2026',
        icon: VideoCameraRegularIcon,
        exploreLink: '',
        illustration: (
            <div className='flex align-center justify-center pad-16'>
                <NutshellLogoMarkIcon size={140} wrapWithDiv={false} fill={colors.orange} />
            </div>
        ),
        linkCTA: 'Register',
        expiresAt: new Date('2026-02-19T19:00:00Z'),
        actionType: 'external-link',
    },
];

export function getActiveOffers(): Offer[] {
    const now = new Date();

    return UPCOMING_OFFERS.filter((offer) => !offer.expiresAt || offer.expiresAt > now);
}
